import type { ConfigEntry } from '../../../Encounter/new-claims-warning'
import type { UseQueryResult } from '@tanstack/react-query'

import { MdInfoOutline } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { getErrorMessage, useClaimsQuery } from '../../../Encounter/new-claims-warning'

interface Props {
  patientId: string
  clientName: string
}

export function NewClaimsWarning ({ patientId, clientName }: Props): JSX.Element | null {
  const queries = useClaimsQuery(patientId, clientName) as Array<UseQueryResult<{entry: ConfigEntry, count: number}>>

  let relevantQueries = queries.filter(query => query.isError || (query.isSuccess && query.data.count > 0))

  if (!relevantQueries.length) {
    return null
  }

  return (
    <div
      className='m-[20px] relative pt-4 pb-4 pr-3 pl-3 rounded mt-4 gap-3 flex flex-col'
      style={{ backgroundColor: '#e5f1ff' }}
    >
      <div className='flex flex-row items-center gap-1'>
        <MdInfoOutline
          color='#4570ff'
          size='19px'
        />
        <h2 className='text-black text-smx font-light mt-0 mb-0'>New Claims</h2>
      </div>

      <div className='flex flex-col gap-2'>
        {relevantQueries.map((query) => {
          let { entry } = query.data ?? {}

          if (!entry) {
            return null
          }

          return (
            <div
              key={entry.id}
              className='flex flex-row justify-between full-width'
            >
              <Link
                to={entry.redirectUrl({ patientId, clientName })}
                className='text-blue-500'
              >
                {entry.name}
              </Link>

              <span className='text-gray-700'>
                {query.isError && getErrorMessage(query.error)}
                {query.isSuccess && query?.data?.count?.toString(10)}
              </span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
